import {
  CreateExaminationInput,
  Examination,
  Examination_Scoring_Type,
  Trial,
  Trial_File_Type,
} from "@generated/graphql";
import dayjs from "dayjs";
import { GroupAndOpenInfoInputs } from "./Group/types";
import { InfoInputs as PersonalInfoInputs } from "./Personal/components/InfoTab/types";
import { CompetencyMapInputsCompetencyMap } from "./types";

export const getTestingTitle = (
  examination: Pick<Examination, "numericId" | "title"> | undefined,
  trial?: Pick<Trial, "numericId"> | null
) => {
  let title = "Тестирование";

  if (examination) {
    const numericId = trial?.numericId || examination.numericId;
    title = `${title} ${examination.title}, ID ${numericId}`;
  }

  return title;
};

export const getExaminationSendResultType = (isExtendedReport?: boolean) => {
  if (isExtendedReport) return Trial_File_Type.RecruiterReport;
  return Trial_File_Type.CandidateReport;
};

export const getExaminationIsExtendedReport = (trialFileType?: Trial_File_Type) => {
  if (trialFileType === Trial_File_Type.RecruiterReport) return true;
  return false;
};

type FormData = Omit<GroupAndOpenInfoInputs | PersonalInfoInputs, "competencyMap"> & {
  competencyMap?: CompetencyMapInputsCompetencyMap;
};

type ResultAssessmentFormData = Pick<FormData, "scoringType" | "gradeDeterminationMap">;

export const getExaminationResultAssessmentFields = ({
  scoringType,
  gradeDeterminationMap,
}: ResultAssessmentFormData) => ({
  scoringType,
  gradeDeterminationMap:
    scoringType === Examination_Scoring_Type.GradeDetermination
      ? gradeDeterminationMap.map(({ from, to, label }) => ({
          from: Number(from),
          to: Number(to),
          label,
        }))
      : undefined,
});

export const getExaminationAvailableRangeFields = (formData: FormData | GroupAndOpenInfoInputs) => {
  const { availableRange } = formData;

  const availableFrom = availableRange?.from ? dayjs(availableRange.from).toISOString() : undefined;
  const availableTo = availableRange?.to
    ? dayjs(availableRange.to).hour(23).minute(59).second(59).millisecond(0).toISOString()
    : undefined;

  return { availableFrom, availableTo };
};

export const getCreateExaminationBaseData = (formData: FormData): Omit<CreateExaminationInput, "type"> => {
  const { isInterview = false, isSendResult } = formData;
  const passingThreshold = Number(formData.passingThreshold);

  return {
    ...(formData.testingSourceType === "scenario"
      ? { scenarioId: formData.scenario?.id }
      : { competencyMapId: formData.competencyMap?.id }),
    title: formData.title || formData.competencyMap?.title || formData.scenario?.title,
    isSendResult,
    sendResultType: isSendResult ? getExaminationSendResultType(formData.isExtendedReport) : undefined,
    isInterview,
    ...(isInterview
      ? {
          maxFollowups: formData.maxFollowups ? Number(formData.maxFollowups) : undefined,
          threshold: formData.threshold ? Number(formData.threshold) : undefined,
        }
      : {}),
    ...getExaminationAvailableRangeFields(formData),
    ...getExaminationResultAssessmentFields(formData),
    passingThreshold: Number.isNaN(passingThreshold) ? 40 : passingThreshold,
  } as Omit<CreateExaminationInput, "type">;
};
